// ============================================================
// statuts.js — les statuts d'un devis à l'écran, depuis UN vocabulaire
// (`shared/schemas.js`). 6 octobre 2026 : trois écrans portaient chacun
// sa liste, et « production » aurait dû être ajouté trois fois.
// ============================================================
import { DEVIS_STATUSES, LIBELLES_STATUT, STATUTS_VERROUILLES } from '@shared/schemas.js';

/** Ce qu'on choisit à la main. « Expiré » se constate, il ne se choisit pas. */
export const OPTIONS_STATUT = DEVIS_STATUSES
  .filter((s) => s !== 'expired')
  .map((value) => ({ value, label: LIBELLES_STATUT[value] }));

export const FILTRES_STATUT = [{ value: '', label: 'Tous les statuts' }, ...OPTIONS_STATUT];

export const estVerrouille = (status) => STATUTS_VERROUILLES.includes(status);
